// import axios from "axios";
// import msalInstance, { loginRequest } from "../auth/msal";
 

// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// apiClient.interceptors.request.use(async (config) => {
//   try {
//     const account = msalInstance.getActiveAccount();

//     if (!account) {
//       console.warn("No active MSAL account");
//       return config;
//     }

//     // acquireTokenSilent returns the real decrypted JWT
//     const tokenResponse = await msalInstance.acquireTokenSilent({
//       ...loginRequest,   // scopes: ["openid", "profile", "email", "User.Read"]
//       account: account,
//     });

//     console.log("=== API REQUEST ===");
//     console.log("URL:", config.baseURL + config.url);
//     console.log("ID Token (first 50 chars):", tokenResponse.idToken?.substring(0, 50));

//     // idToken is the raw JWT — starts with eyJ
//     config.headers.Authorization = `Bearer ${tokenResponse.idToken}`;

//   } catch (err) {
//     console.error("Token acquisition failed:", err);
//   }

//   return config;
// });

// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.error("PSI360 API: Unauthorized — token may be expired");
//     }
//     return Promise.reject(error);
//   }
// );

// export default apiClient;
 
import axios from "axios";
import msalInstance, { loginRequest } from "../auth/msal";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ── Request interceptor: attach fresh token to every call ────────────────────
apiClient.interceptors.request.use(async (config) => {
  try {
    const account = msalInstance.getActiveAccount();

    if (!account) {
      console.warn("No active MSAL account");
      return config;
    }

    const tokenResponse = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    console.log("=== API REQUEST ===");
    console.log("URL:", config.baseURL + config.url);
    console.log("ID Token (first 50 chars):", tokenResponse.idToken?.substring(0, 50));

    config.headers.Authorization = `Bearer ${tokenResponse.idToken}`;

  } catch (err) {
    console.error("Token acquisition failed:", err);
  }

  return config;
});

// ── Response interceptor: on 401, force-refresh token and retry ONCE ─────────
let _isRefreshing = false;
let _pendingQueue = [];

const processQueue = (error, token = null) => {
  _pendingQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  _pendingQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Only handle 401, only retry once
    if (error.response?.status !== 401 || originalRequest._retried) {
      return Promise.reject(error);
    }

    // If a refresh is already in flight, queue this request
    if (_isRefreshing) {
      return new Promise((resolve, reject) => {
        _pendingQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers["Authorization"] = `Bearer ${token}`;
        return apiClient(originalRequest);
      });
    }

    originalRequest._retried = true;
    _isRefreshing = true;

    const account = msalInstance.getActiveAccount();

    try {
      // forceRefresh: true — bypass cache, get a brand new token from Azure
      const tokenResponse = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
        forceRefresh: true,
      });

      const newToken = tokenResponse.idToken;
      console.log("[API] Token refreshed successfully after 401.");

      originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
      processQueue(null, newToken);
      return apiClient(originalRequest);

    } catch (refreshErr) {
      // Refresh token is dead — session is unrecoverable, force logout
      processQueue(refreshErr, null);
      console.warn("[API] Token refresh failed after 401 — forcing logout.", refreshErr);

      msalInstance.logoutRedirect({
        account: account ?? undefined,
      });

      return Promise.reject(refreshErr);

    } finally {
      _isRefreshing = false;
    }
  }
);

export default apiClient;